import React, { useState } from 'react';
import styled from 'styled-components';
import ReactCardFlip from 'react-card-flip';
import LabelView from './LabelView';

const FlashCard = ({ className, item }) => {
  const [isFliped, setIsFliped] = useState(false);
  return (
    <ReactCardFlip isFlipped={isFliped} flipDirection="horizontal">
      <div className={className}>
        <div className="text-conteiner">
          <LabelView
            title={''}
            text={item.situacao_problema ? item.situacao_problema : '-'}
            html
            name="comando_resposta"
          />
        </div>
        <button
          className="btn-v"
          onClick={() => {
            setIsFliped(!isFliped);
          }}
        >
          Virar
        </button>
      </div>
      <div className={className} style={{ background: '#c6c6c6' }}>
        <div className="text-conteiner-1">
          <LabelView
            title={''}
            text={item.comando_resposta ? item.comando_resposta : '-'}
            html
            name="comando_resposta"
          />
        </div>
        <button
          className="btn-v"
          onClick={() => {
            setIsFliped(!isFliped);
          }}
        >
          Virar
        </button>
      </div>
    </ReactCardFlip>
  );
};
export default styled(FlashCard)`
  background: #fff;
  margin: 1rem;
  min-height: 15rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 90%;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgba(58, 58, 58, 0.5);
  .text-conteiner {
    min-height: 13rem;
    widht: 100%;
    display: flex;
    align-items: center;
  }
  .text-conteiner-1 {
    min-height: 13rem;
    widht: 100%;
    display: flex;
    align-items: center;
  }
  .btn-v {
    border-width: 1px;
    margin-top: 1rem;
    margin-bottom: 2rem;
    min-width: 50%;
    min-height: 2rem;
    background: #fff;
    border-color: #000;
    border-radius: 8px;
    &:hover {
      background: #000;
      color: #fff;
    }
  }
`;
